// src/config/watchdog.ts

// Read ONLY from .env (or Render)
export const ENABLE_WATCHDOG =
  (process.env.REACT_APP_ENABLE_NUDGE_WATCHDOG || "true").toLowerCase() === "true";

const toMs = (v: any, fallback: number) => {
  if (v == null) return fallback;
  let s = String(v).trim().split("#")[0].split("//")[0].trim().replace(/_/g, "");
  const n = Number(s);
  return Number.isFinite(n) && n >= 0 ? n : fallback;
};

const toInt = (v: any, fallback: number) => {
  const n = Number(v);
  return Number.isFinite(n) && n >= 0 ? Math.floor(n) : fallback;
};

// Frequencies / thresholds
let interval = toMs(process.env.REACT_APP_WATCHDOG_INTERVAL_MS, 30_000);
const idle   = toMs(process.env.REACT_APP_WATCHDOG_IDLE_THRESHOLD_MS, 180_000);

// Guard: sample at least twice within idle window
if (interval > idle) interval = Math.max(Math.floor(idle / 2), 500);

// NEW: maximum nudges per session/tab (default 3)
export const WATCHDOG_MAX_NUDGES = Math.max(
  0,
  toInt(process.env.REACT_APP_WATCHDOG_MAX_NUDGES, 3)
);

export const WATCHDOG_INTERVAL_MS = interval;
export const WATCHDOG_IDLE_THRESHOLD_MS = idle;

if (process.env.NODE_ENV !== "production") {
  // eslint-disable-next-line no-console
  console.log("[watchdog config]", {
    ENABLE_WATCHDOG,
    WATCHDOG_INTERVAL_MS,
    WATCHDOG_IDLE_THRESHOLD_MS,
    WATCHDOG_MAX_NUDGES,
  });
}
